var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-schema-form', { ref: "form", staticClass: "advertiser-info", attrs: { "schema": _vm.schema, "model": _vm.model, "config": _vm.formConfig }, on: { "add": _vm.handleAddField, "remove": _vm.handleRemoveField } }, [_c('div', { staticClass: "action-bar" }, [_c('el-button', { on: { "click": _vm.cancel } }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', _vm._b({ on: { "click": _vm.submit } }, 'el-button', _vm.submitButton, false), [_vm._v("确 定")])], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };